'use client';

import Image from 'next/image';

import { AUTHORIZED_SHOPS } from '~/constants/shop';
import mandarakeTopBanner from '~/public/assets/images/mandarake_top_image_4x.webp';
import ragTagTopBanner from '~/public/assets/images/ragtag_top_image_4x.webp';

import styles from './ShopBanner.module.css';
type Props = {
  shopId: string;
};
export const ShopBanner = ({ shopId }: Props) => {
  const renderImageByShopId = (_shopId: string) => {
    switch (_shopId) {
      case AUTHORIZED_SHOPS.mandarake.id:
        return <Image src={mandarakeTopBanner} width={375} height={150} priority unoptimized alt="만다라케 탑 배너" />;
      case AUTHORIZED_SHOPS.ragTag.id:
        return <Image src={ragTagTopBanner} width={375} height={150} priority unoptimized alt="래그태그 탑 배너" />;
      default:
        return null;
    }
  };
  return <div className={styles.container}>{renderImageByShopId(shopId)}</div>;
};
